import {combineReducers} from 'redux';
import * as DELETE_ACTION from './constants';

let isProcessing = (state = false, action) => {
    let {type} = action;

    switch (type) {
        case DELETE_ACTION.BEGIN_CHANGE_PACKAGE_TRANSPORT_STATUS:
            return true;
        case DELETE_ACTION.CHANGE_PACKAGE_TRANSPORT_STATUS.SUCCESS:
        case DELETE_ACTION.CHANGE_PACKAGE_TRANSPORT_STATUS.FAILED:
        case DELETE_ACTION.END_CHANGE_PACKAGE_TRANSPORT_STATUS:
            return false;
        default:
            return state;
    }
};

let loading = (state = false, action) => {
    let {type} = action;

    switch (type) {
        case DELETE_ACTION.CHANGE_PACKAGE_TRANSPORT_STATUS.REQUEST:
            return true;
        case DELETE_ACTION.CHANGE_PACKAGE_TRANSPORT_STATUS.SUCCESS:
        case DELETE_ACTION.CHANGE_PACKAGE_TRANSPORT_STATUS.FAILED:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    isProcessing,
    loading
});
